"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMessageListener = addMessageListener;
exports.addEmbedMessageListener = addEmbedMessageListener;
var utils_1 = require("../utils");
function addMessageListener(_a) {
    var frames = _a.frames, subscriptions = _a.subscriptions;
    window.addEventListener("message", function (event) {
        var _a;
        var _b = event.data, type = _b.type, payload = _b.payload;
        if (window.Chathive.widget.isHidden() || !((_a = Object.keys(frames)) === null || _a === void 0 ? void 0 : _a.length))
            return;
        switch (type) {
            case "widget.init":
                window.Chathive.widget.initWidget();
                if (payload.frameConfig) {
                    Object.values(frames).forEach(function (frame) { return (0, utils_1.resizeFrame)({ frame: frame, config: payload.frameConfig }); });
                }
                Object.values(frames).forEach(function (frame) { return (0, utils_1.setFrameVisibility)({ frame: frame, isVisible: true }); });
                break;
            case "widget.opened":
                if (!frames.main)
                    break;
                (0, utils_1.resizeFrame)({ frame: frames.main, config: payload });
                break;
            case "widget.closed":
                if (!frames.main)
                    break;
                (0, utils_1.resizeFrame)({ frame: frames.main, config: payload });
                break;
            case "parent.resize":
                Object.values(frames).forEach(function (frame) { return (0, utils_1.resizeFrame)({ frame: frame, config: payload }); });
                break;
            default:
                break;
        }
        (0, utils_1.executeSubscriptions)({ events: [type], subscriptions: subscriptions, payload: payload });
    });
}
function addEmbedMessageListener(_a) {
    var frames = _a.frames, subscriptions = _a.subscriptions;
    window.addEventListener("message", function (event) {
        var _a;
        var _b = event.data, type = _b.type, payload = _b.payload;
        if (window.Chathive.widget.isHidden() || !((_a = Object.keys(frames)) === null || _a === void 0 ? void 0 : _a.length))
            return;
        switch (type) {
            case "widget.init":
                window.Chathive.widget.initWidget();
                if (payload.frameConfig) {
                    Object.values(frames).forEach(function (frame) { return (0, utils_1.resizeFrame)({ frame: frame, config: payload.frameConfig }); });
                }
                Object.values(frames).forEach(function (frame) { return (0, utils_1.setFrameVisibility)({ frame: frame, isVisible: true }); });
                break;
            default:
                break;
        }
        (0, utils_1.executeSubscriptions)({ events: [type], subscriptions: subscriptions, payload: payload });
    });
}
exports.default = {};
